import { Link, useLocation } from 'react-router-dom';
import { Armchair, LayoutDashboard, CalendarRange, Sparkles, User } from 'lucide-react';
import { cn } from '../../lib/utils';

export function BottomNav() {
    const location = useLocation();

    const tabs = [
        { name: 'Seats', icon: Armchair, path: '/seats' },
        { name: 'Dashboard', icon: LayoutDashboard, path: '/dashboard' },
        { name: 'Users', icon: User, path: '/users' },
        { name: 'Subscriptions', icon: CalendarRange, path: '/subscriptions' },
        { name: 'Reflect', icon: Sparkles, path: '/chatbot' },
    ];

    return (
        <div className="fixed bottom-0 left-0 right-0 border-t bg-background/80 backdrop-blur-md pb-safe">
            <div className="flex h-16 items-center justify-around px-2">
                {tabs.map((tab) => {
                    const isActive = location.pathname.startsWith(tab.path);
                    return (
                        <Link
                            key={tab.name}
                            to={tab.path}
                            className={cn(
                                "flex flex-col items-center justify-center w-full h-full gap-1 text-xs font-medium transition-colors hover:text-primary",
                                isActive ? "text-primary" : "text-muted-foreground"
                            )}
                        >
                            <tab.icon className={cn("h-5 w-5", isActive && "fill-current")} />
                            <span>{tab.name}</span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
